/**
 * Custom hook that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby';

function useLadiesCollectionGraphQL() {
  const data = useStaticQuery(
    graphql`
      {
        ladiesCollectionHeroImage: file(
          relativePath: { eq: "collections/ladies/hero-ladies.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        ladiesGregNormanImage: file(
          relativePath: { eq: "collections/ladies/greg-norman-ladies.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        ladiesBermudaSandsImage: file(
          relativePath: { eq: "collections/ladies/bermuda-sands-ladies.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 520) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        ladiesNivoImage: file(
          relativePath: { eq: "collections/ladies/card-nivo2.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 860) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        ladiesCorsicanGolfImage: file(
          relativePath: { eq: "collections/ladies/card-corsican-golf.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        ladiesDailySportsImage: file(
          relativePath: { eq: "collections/ladies/daily-sports.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 860) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        ladiesJamieSadockImage: file(
          relativePath: { eq: "collections/ladies/jamie-sadock.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 520) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );
  return data;
}

export { useLadiesCollectionGraphQL };
